import React from "react";
import styled from 'styled-components';
import {ButtonList} from "../styles/Button";
import Button from "../Button/Button";
import PropTypes from "prop-types";

const DelIpContainer = styled.div`
	& > p {
		margin-bottom: 16px;
		
		& > span {
			font-weight: bold;
		}
	}
`;

const DellIp = ({ itemIp, hide, onClick }) => {

	return (
		<DelIpContainer>
			<p>Удалить IP-адрес <span>{itemIp ? itemIp.ip : ''}</span>?</p>
			<ButtonList>
				<Button onClick={onClick}>Удалить</Button>
				<Button onClick={hide}>Отмена</Button>
			</ButtonList>
		</DelIpContainer>
	)
};

DellIp.propTypes = {
	itemIp: PropTypes.object,
	hide: PropTypes.func,
	onClick: PropTypes.func
};

export default DellIp;